"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DialogBackdropMotion", {
    enumerable: true,
    get: function() {
        return DialogBackdropMotion;
    }
});
const _reactmotion = require("@fluentui/react-motion");
const keyframes = [
    {
        opacity: 0
    },
    {
        opacity: 1
    }
];
const DialogBackdropMotion = (0, _reactmotion.createPresenceComponent)({
    enter: {
        keyframes,
        easing: _reactmotion.motionTokens.curveLinear,
        duration: _reactmotion.motionTokens.durationGentle
    },
    exit: {
        keyframes: [
            ...keyframes
        ].reverse(),
        easing: _reactmotion.motionTokens.curveLinear,
        duration: _reactmotion.motionTokens.durationGentle
    }
});
